const LEGAL_SUFFIX_PATTERN = /\b(s\s*a|sa|nv|bv|sprl|srl|sarl|sas|scrl|cvba|comm\.?\s*v|gmbh|ag|kg|ltd|limited|llc|inc|incorporated|plc|corp|corporation|co|company|group|holding|holdings|belgium|belgique|belgie|belgië|international|intl)\b/g;

export const normalizeCompanyName = (name: string): string => {
	if (!name) return '';
	const stripped = name
		.toLowerCase()
		.replace(/[.,()&'"\/]/g, ' ')
		.replace(LEGAL_SUFFIX_PATTERN, ' ')
		.replace(/\s+/g, ' ')
		.trim();
	// If everything was a suffix, fall back to the lowercased original (still better than '').
	return stripped.length > 0 ? stripped : name.toLowerCase().trim();
};
